import TopButtonRenderer from "./TopButtonRenderer";
import addInteractivity from "../../../utils/addInteractivity";
import { EnumRootEventBus, rootEventBus } from "../../../managers/RootEventBus";
import { TopSwitcherOptions } from "../../../types/Interface";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class TopButton {
  TopButtonRenderer!: TopButtonRenderer;
  private isSelected: boolean = false;
  constructor(private eventBusName: string, private label: string, private _handleDownFunc: () => void, options?: TopSwitcherOptions) {
    this.TopButtonRenderer = new TopButtonRenderer(this.label, options);

    addInteractivity(
      this.TopButtonRenderer,
      {
        handleOverFunc: () => this.isOver(true),
        handleDownFunc: () => this.handleDownFunc(),
        handleLeaveFunc: () => this.isOver(false)
      },
      CustomCursorType.pointer,
      undefined,
      true
    )
    rootEventBus.on(EnumRootEventBus.topSwitcherButtonLabel, (eventBusName: string, label: string) => {
      eventBusName == this.eventBusName && (this.isSelected = this.label === label);
      this.checkIsSelected()
    })
  }
  private isOver = (v: boolean) => v ? this.TopButtonRenderer.drawBottomBg(0xEDEDED) : this.TopButtonRenderer.drawBottomBg(0xFFFFFF);
  private checkIsSelected = () => this.isSelected ? this.TopButtonRenderer.drawMidBg() : this.TopButtonRenderer.clearMidBg();

  handleDownFunc() {
    if (this.isSelected) { return }
    rootEventBus.emit(EnumRootEventBus.topSwitcherButtonLabel, this.eventBusName, this.label)
    this._handleDownFunc();
  }
}